import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { Translate } from '../../modules/Translations'

import config from '../../config'

import './styles.css'

const PageLink = ({to, exact, className}) => {
    var page = config.Pages[to];
    return page ? <NavLink to={to} className={className} exact={exact} title={page.title}><Translate string={page.title} defaultString={page.title}/></NavLink> : null
}

const MainNavigation = () => {
    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark" style={{backgroundColor: "#f5ead3"}}>
            <div className="container">
                <NavLink className="navbar-brand" exact to="/"><Translate string='project.name' /></NavLink>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item">
                            <PageLink className="nav-link" exact to="/" />
                        </li>
                        <li className="nav-item">
                            <PageLink className="nav-link" exact to="/the-project" />
                        </li>
                        <li className="nav-item">
                        </li>
                        <li className="nav-item">
                            <PageLink className="nav-link" exact to="/travels" />
                        </li>
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown2" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <Translate string="Авторство" defaultString="Авторство"/>
                            </a>
                            <div className="dropdown-menu" aria-labelledby="navbarDropdown2">
                                <PageLink className="dropdown-item" exact to="/ekip" />
                                <PageLink className="dropdown-item" exact to="/publications" />
                                <PageLink className="dropdown-item" exact to="/conferences" />
                                <PageLink className="dropdown-item" exact to="/copyright" />
                            </div>
                        </li>
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <Translate string="Ръкописите" defaultString="Ръкописите"/>
                            </a>
                            <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                <PageLink className="dropdown-item" to="/kompilativna-redakcia" />
                                <div className="dropdown-divider"></div>
                                <div className="dropdown-item disabled"><strong>Съхранени в България:</strong></div>
                                <PageLink className="dropdown-item" to="/rilska-prepravka" />
                                <PageLink className="dropdown-item" to="/pop-yoanova-prepravka" />
                                <PageLink className="dropdown-item" to="/haritonova-prepravka-1" />
                                <PageLink className="dropdown-item" to="/haritonova-prepravka-2" />
                                <PageLink className="dropdown-item" to="/starozagorska-prepravka-1" />
                                <PageLink className="dropdown-item" to="/gerov-prepis" />
                                <PageLink className="dropdown-item" to="/kesariev-prepis" />
                                <PageLink className="dropdown-item" to="/panagyurski-prepis" />
                                <div className="dropdown-divider"></div>
                                <div className="dropdown-item disabled"><strong>Съхранени в чужбина:</strong></div>
                                <PageLink className="dropdown-item" to="/hilendarska-prepravka-1" />
                                <PageLink className="dropdown-item" to="/grigorovicheva-prepravka" />
                                <div className="dropdown-divider"></div>
                                <div className="dropdown-item disabled"><strong>Изгубени ръкописи:</strong></div>
                                <PageLink className="dropdown-item" to="/haritonova-prepravka-3" />
                                <PageLink className="dropdown-item" to="/lamanski-prepis" />
                                <PageLink className="dropdown-item" to="/gavril-krustevich-manuscripts" />
                                <div className="dropdown-divider"></div>
                                <PageLink className="dropdown-item" to="/bibliography" />
                            </div>
                        </li>
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown3" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <Translate string="Хората разкази" defaultString="Хората разкази"/>
                            </a>
                            <div className="dropdown-menu" aria-labelledby="navbarDropdown3">
                                <PageLink className="dropdown-item" exact to="/horata-razkazi" />
                                <PageLink className="dropdown-item" exact to="/horata-razkazi/zavrazkata" />
                                <PageLink className="dropdown-item" exact to="/horata-razkazi/kuluminacii" />
                                <PageLink className="dropdown-item" exact to="/horata-razkazi/ne-znainite" />
                                <PageLink className="dropdown-item" exact to="/horata-razkazi/posleslov" />
                            </div>
                        </li>
                        <li className="nav-item">
                           <PageLink className="nav-link" to="/fondation" />
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}

MainNavigation.propTypes = {

}

export default MainNavigation



// WEBPACK FOOTER //
// ./src/components/Navigation/index.jsx